import Footer from '@pok/weblib/ui/Footer.jsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default function FooterContainer() {
    const { i18n, t } = useTranslation();
    const location = useLocation();
    const isAcceptScreen = location.pathname.startsWith('/accept');
    return (
        <>
            {!isAcceptScreen && (
                <Footer
                    domain={'pok.tech'}
                    institutionalSite={import.meta.env.VITE_INSTITUTIONAL_BASE_URI}
                    pokName={'pok'}
                    country={i18n.language}
                    t={t}
                />
            )}
        </>
    );
}
